import React, { memo } from 'react'

import EmptyAvatarIcon from 'app/assets/icons/store-empty-avatar.svg'
import Avatar from 'app/components/base/Avatar'
import Skeleton from 'app/components/base/Skeleton'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

import NameWithLocation from './components/NameWithLocation'
import PoweredByBlock from './components/PoweredByBlock'

interface StoreBusinessUserInfoFeatureProps {
  avatarUrl?: string
  location?: string
  loading?: boolean
  rating?: number
  name?: string
  storeDescription?: string
  taxNumber?: string
}

const StoreBusinessUserInfoFeature: RFC<StoreBusinessUserInfoFeatureProps> = ({
  avatarUrl,
  location,
  loading,
  rating,
  name,
  storeDescription,
  taxNumber
}) => {
  return (
    <Stack direction="column" spacing={2}>
      <Stack spacing={1}>
        <PoweredByBlock />

        <Stack spacing={{ md: 3, xs: 2 }} direction="row">
          <Avatar
            src={avatarUrl}
            sizes="150px"
            width={120}
            height={120}
            loading={loading}
            icon={<EmptyAvatarIcon />}
            sx={{
              width: 120,
              height: 120,
              minWidth: 120,
              borderWidth: 1,
              borderColor: 'border.main',
              borderRadius: 0,
              backgroundColor: 'background.default',
              ...(!avatarUrl && {
                borderStyle: 'solid',
                backgroundColor: 'background.dark'
              })
            }}
            {...(IS_NATIVE_APP && { layout: 'fill', sizes: '256px' })}
          />

          <NameWithLocation
            name={name}
            location={location}
            isLoading={loading}
            rating={rating}
            taxNumber={taxNumber}
          />
        </Stack>
      </Stack>

      <Skeleton loading={loading} width="100%" height={40}>
        {!!storeDescription && (
          <Text
            variant="body2"
            sx={{
              color: 'text.third',
              ...(!IS_NATIVE_APP && { wordBreak: 'break-word' })
            }}
          >
            {storeDescription}
          </Text>
        )}
      </Skeleton>
    </Stack>
  )
}

export default memo(StoreBusinessUserInfoFeature)
